// extracted by mini-css-extract-plugin
export default {"adminContainer":"styles_adminContainer__zTyFn","adminAccess":"styles_adminAccess__OYAbZ"};